import ResultBody from "src/modules/3rd-party-management/pages/admin/compliance/screening/pages/result-detail/components/result-body";
import { useLocation } from "react-router-dom";

const ScreeningResultDetails = ({ id, supplierId }) => {
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);

    return (
        <ResultBody
            id={id}
            supplierId={supplierId}
            type={searchParams.get('type')}
        />
    )
}

export default ScreeningResultDetails;